<template>
    <div class="modal fade show" id="sleepData" tabindex="-1" role="dialog" aria-labelledby="sleepData" aria-hidden="true" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel" v-if="form_type == 1">Mood</h4>
                    <h4 class="modal-title" id="myModalLabel" v-if="form_type == 2">Energy</h4>
                    <button type="button" class="close" @click.prevent="$parent.toggleForm()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body ">
                    <loader v-if="pageLoader"></loader>
                    <div class="radio-section" v-if="form_type == 1">
                        <h3>How you feeling today?</h3>
                        <ul class="mood pt-3 d-flex flex-wrap custom-radio-wrap justify-content-between align-items-center">
                            <li class="form-group field-wrapper  align-items-center" v-for="item in moodOptions" :class="[{'active':data_value == item.value}]">
                                <input type="radio" name="mood" :value="item.value" :id="item.value" v-model="data_value" >
                                <label class="custom-radio" :for="item.value"></label>
                                <span class="pl-2 label-text">{{item.label}}</span>
                            </li>
                            <p class="error" v-if="submitted && errors.has('mood')">{{ error.first('mood') }}</p>
                        </ul>
                    </div>
                    <div class="form-group field-wrapper mb-0" v-if="form_type == 2">
                        <h3>How is your energy level today?</h3>
                        <div class="position-relative rangeSection mt-4">
                            <div class="range-value" :style="'left :' + leftVal + ';'"><span>{{data_value}}%</span></div>
                            <input class="progressbar" type="range" min="0" max="100" name="energy Level" v-model="data_value" v-validate="'required'">
                            <p class="error" v-if="submitted" v-for="error in errors.collect('energy Level')">{{ error }}</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default red" data-dismiss="modal" @click.prevent="$parent.toggleForm()">Close</button>
                    <button type="button" class="btn btn-default btn-blue" @click.prevent="UploadtestReport()">Save changes</button>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    import moment from 'moment'
    export default {
        name: "Mood-Form",
        data() {
            return {
                pageLoader : false,
                submitted : false,
                data_value: '',
            };
        },
        props:{
            form_type:{
                default: 1
            }
        },
        watch:{
            form_type(){
                this.data_value = ''
            }
        },
        methods:{
            onFileChange(event){
                var fileData =  event;
                this.fileName = fileData.name;
            },
            UploadtestReport(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json = {
                            'globalParams' : {
                                data_type: _that.form_type,
                                emotion_time: moment().format('YYYY-MM-DD HH:mm:ss'),
                            },'localParams' : {'parameter' : _that}
                        };
                        if(_that.form_type == 1){
                            input_json.globalParams['type'] = _that.data_value
                        }else{
                            input_json.globalParams['info'] = _that.data_value
                        }
                        this._runAddEmotionData(input_json)
                    }
                }); 
            },
            reset(){
                this.submitted = false
                this.data_value = ''
            }
        },
        computed:{
            leftVal(){
                let newValue = this.data_value
                let newPosition = 10 - (newValue * 0.2);
                return `calc(${newValue}% + (${newPosition}px))`
            }
        },
        created(){
            if(this.form_type == 1){
                this.data_value = this.initialData.mood._id ? this.initialData.mood.type : ''
            }else{
                this.data_value = this.initialData.energy._id ? (this.initialData.energy.info || 0) : 0
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/user/forms/mood-form.vue